<template>
  <div id="QueryTrainer">
    查询教练员
  </div>
</template>

<script>
export default {
  name: "QueryTrainer",
  // 注册组件
  components: {},
  // 属性
  props: {},
  // 页面数据
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  // 观察者
  watch: {},
  // 计算属性
  computed: {},
  methods: {}
}
</script>

<style scoped>

</style>
